import React, { Component } from 'react';

import { browserHistory, withRouter } from 'react-router';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import {
  StyledHeader,
  StyledMain,
  StyledHeaderContainer,
  StyledAddButton,
  StyledTableContainer,
} from 'helpers/StyledTableComponentsHelper';

import * as landlordTenantsActions from 'actions/landlordTenantsActions';

import { openEditLease } from 'actions/LeaseDetailsActions';
import { getProperties, getUnits } from 'actions/landlordPropertiesActions';
import { getCompanyDetails } from 'actions/companyDetailsActions';
import { getCompanyPreferences } from 'actions/companyDetailsActions';
import { getSignableDocClientId } from 'actions/landlordSignableDocActions';

import { AccentColor } from 'helpers/AccentColorHelper';

import LeaseOverview from './LeaseOverview/LeaseOverview';
import HeaderWithPeriod from 'components/shared/HeaderWithPeriod';
import RentRollNonGrid from './components/RentRollNonGrid';
import YardiRenewalsWizard from './renewals/components';
import InPersonDocumentSigningWizard from './LeaseOverview/InPersonDocumentSigningWizard';

import { drawerStyle } from 'helpers/tableHelpers';
import { RentRollStatus } from 'components/shared/StatusHelper';
import { toFriendlyDateString, formatMoney } from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

import withMobileDialog from '@material-ui/core/withMobileDialog';

import { MuiThemeProvider } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import { createMuiTheme } from '@material-ui/core/styles';

import TableFilters from 'components/ui/TableFilters';
import TabbedTable from 'components/ui/TabbedTable';
import MobileTable from 'components/ui/MobileTable';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';

const propertyTypes = [
  'apartment',
  'student',
  'condo',
  'single_family',
  'residential',
  'office',
  'commercial',
  'industrial',
  'mobile_home',
  'parking_lot',
];

const occupancyTypes = ['vacant'];

export default withMobileDialog()(
  connect(
    store => ({
      fetchingRentRoll: store.landlordTenants.fetchingRentRoll,
      rentRoll: store.landlordTenants.rentRoll,
      rentRollCount: store.landlordTenants.rentRollCounts,
      leaseDetails: store.leaseDetails.leaseDetails,
      properties: store.landlordProperties.properties,
      documentToSign: store.landlordApplications.documentToSign,
    }),
    {
      ...landlordTenantsActions,
      openEditLease,
      getProperties,
      getUnits,
      getCompanyPreferences,
      getCompanyDetails,
      getSignableDocClientId,
    }
  )(
    withRouter(
      class RentRoll extends Component {
        constructor(props) {
          super(props);
          this.state = {
            showFilters: true,
            filtersActive: false,
            filters: {
              search: '',
              properties: Array(this.props.properties.length).fill(false),
              property_types: Array(propertyTypes.length).fill(false),
              occupancy_types: Array(occupancyTypes.length).fill(false),
            },
            currentTab: 'rent_roll',
            sortKey: '',
            sortOrder: '',
            offset: 0,
            drawerIsOpen: false,
            inPersonDocumentSigning: false,
          };
        }

        setRef = ref => (this.table = ref);

        fetchRentRollAndStats = () => {
          this.props.getRentRollStats();
          this.fetchRentRoll();
        };

        fetchRentRoll = (updateList = false) => {
          let { filters, filtersActive, currentTab, offset, sortKey, sortOrder } = this.state;

          let fetchPromise = null;

          let filterOptions = {
            sort_key: sortKey,
            sort_order: sortOrder,
          };

          if (updateList) {
            offset = 0;
          }

          if (filtersActive) {
            const propertiesToFilter = this.filterProperties(filters.properties).map(
              data => data.value
            );

            const propertyTypesToFilter = this.filterPropertyTypes(filters.property_types);

            const occupancyTypesToFilter = this.filterOccupancyTypes(filters.occupancy_types);

            filterOptions = {
              query: filters.search,
              property_ids: propertiesToFilter,
              sort_key: sortKey,
              sort_order: sortOrder,
              property_types: propertyTypesToFilter,
              occupancy_types: occupancyTypesToFilter,
            };

            fetchPromise = this.props.getFilteredRentRoll('all', offset, filterOptions);
          } else {
            fetchPromise = this.props.getFilteredRentRoll(currentTab, offset, filterOptions);
          }

          fetchPromise.then(() => {
            this.setState({
              offset: this.props.rentRoll.length,
            });
          });
        };

        componentDidMount = () => {
          this.fetchRentRollAndStats();
          this.props.getProperties({ for_multiselect: true, show_cities: true });
          this.props.getCompanyPreferences();
          this.props.getCompanyDetails();
          this.props.getSignableDocClientId();

          const { leaseId } = this.props.routeParams;
          if (leaseId) {
            this.toggleDrawer(leaseId);
          }
        };

        filterProperties = booleanArrayMask => {
          return this.props.properties.filter((_, i) => booleanArrayMask[i]);
        };

        filterPropertyTypes = booleanArrayMask => {
          return propertyTypes.filter((_, i) => booleanArrayMask[i]);
        };

        filterOccupancyTypes = booleanArrayMask => {
          return occupancyTypes.filter((_, i) => booleanArrayMask[i]);
        };

        handleClearSearch = setFieldValue => {
          this.setState(
            {
              filtersActive: false,
              filters: {
                search: '',
                properties: Array(this.props.properties.length).fill(false),
                property_types: Array(propertyTypes.length).fill(false),
                occupancy_types: Array(occupancyTypes.length).fill(false),
              },
              offset: 0,
            },
            () => this.fetchRentRoll()
          );
          if (this.table) this.table.scrollToTop(0);
          setFieldValue('search', '');
          setFieldValue('properties', Array(this.props.properties.length).fill(false));
          setFieldValue('property_types', Array(propertyTypes.length).fill(false));
          setFieldValue('occupancy_types', Array(occupancyTypes.length).fill(false));
        };

        handleFilters = values => {
          const isFiltersUntouched =
            values.search === '' &&
            !values.properties.includes(true) &&
            !values.occupancy_types.includes(true) &&
            !values.property_types.includes(true);
          const newState = {
            filtersActive: !isFiltersUntouched,
            filters: {
              search: values.search,
              properties: values.properties,
              property_types: values.property_types,
              occupancy_types: values.occupancy_types,
            },
            drawerVisible: false,
            offset: 0,
          };
          if (this.table) this.table.scrollToTop(0);
          this.setState(newState, () => this.fetchRentRoll());
        };

        handleSort = (key, order) => {
          this.setState(
            {
              sortKey: key,
              sortOrder: order,
              offset: 0,
            },
            () => {
              this.fetchRentRoll();
            }
          );
          if (this.table) this.table.scrollToTop(0);
        };

        columns = () => {
          return [
            {
              title: getTranslatedString('landlordPortal.rentRoll.status'),
              dataKey: 'status',
              sortable: false,
              width: 200,
              render: ({ rowData }) => (
                <RentRollStatus className="ticket_status_label_rent_roll" leaseDetails={rowData} />
              ),
            },
            {
              title: getTranslatedString('landlordPortal.rentRoll.unitNumber'),
              dataKey: 'unit_number',
              sortable: true,
              width: 125,
            },
            {
              title: getTranslatedString('landlordPortal.rentRoll.residents'),
              dataKey: 'cotenant_full_names',
              sortable: !['rent_roll', 'vacant'].includes(this.state.currentTab),
              width: 450,
              render: ({ data }) => data || 'Vacant',
            },
            {
              title: getTranslatedString('landlordPortal.rentRoll.leaseStartDate'),
              dataKey: 'lease_start_date',
              sortable: !['rent_roll', 'vacant'].includes(this.state.currentTab),
              width: 175,
              render: ({ data }) => toFriendlyDateString(data),
            },
            {
              title: getTranslatedString('landlordPortal.rentRoll.leaseEndDate'),
              dataKey: 'lease_end_date',
              sortable: !['rent_roll', 'vacant'].includes(this.state.currentTab),
              width: 150,
              render: ({ data }) => toFriendlyDateString(data),
            },
            {
              title: getTranslatedString('landlordPortal.rentRoll.totalMonthlyRent'),
              dataKey: 'total_monthly_rent',
              sortable: !['rent_roll', 'vacant'].includes(this.state.currentTab),
              width: 200,
              render: ({ data }) => (data ? formatMoney(data) : ''),
            },
            {
              title: getTranslatedString('landlordPortal.rentRoll.guarantor'),
              dataKey: 'has_guarantor',
              sortable: false,
              width: 250,
              render: ({ data }) =>
                data
                  ? getTranslatedString('landlordPortal.rentRoll.guarantorYes')
                  : getTranslatedString('landlordPortal.rentRoll.guarantorNo'),
            },
          ];
        };

        handleTabChange = tabName => {
          this.setState(
            {
              currentTab: tabName,
              offset: 0,
            },
            () => {
              this.fetchRentRoll();
            }
          );
          if (this.table) this.table.scrollToTop(0);
        };

        accentColor = AccentColor();

        toggleDrawer = leaseID => {
          if (!this.state.showDrawer && leaseID && !leaseID.type) {
            this.props.openEditLease(leaseID).then(() => {
              this.setState({
                showDrawer: true,
              });
            });
            browserHistory.push(`/companies/rent_roll/${leaseID}`);
            return;
          }

          this.setState({
            showDrawer: false,
          });
          browserHistory.push('/companies/rent_roll');
        };

        updateLeaseDetails = formData => {
          return this.props.putManualLease(formData, this.props.leaseDetails.id).then(() => {
            this.setState(
              {
                offset: 0,
              },
              () => this.fetchRentRoll()
            );
            this.props.openEditLease(this.props.leaseDetails.id);
          });
        };

        toggleInPersonDocumentSigning = () => {
          this.setState({
            inPersonDocumentSigning: !this.state.inPersonDocumentSigning,
          });
        };

        render() {
          const { filters } = this.state;
          const { rentRoll, rentRollCount } = this.props;

          const filterOptions = [
            {
              useSearch: true,
              options: this.props.properties.map(data => data.label),
              name: 'properties',
              title: getTranslatedString('landlordPortal.rentRoll.selectPropertiesToFilter'),
            },
            {
              useSearch: false,
              options: propertyTypes,
              name: 'property_types',
              title: getTranslatedString('landlordPortal.rentRoll.filterByPropertyType'),
            },
            {
              useSearch: false,
              options: occupancyTypes,
              name: 'occupancy_types',
              title: getTranslatedString('landlordPortal.rentRoll.filterByOccupancyType'),
            },
          ];

          const tabs = [
            {
              title: getTranslatedString('landlordPortal.rentRoll.rentRoll'),
              label: getTranslatedString('landlordPortal.rentRoll.rentRoll'),
              value: 'rent_roll',
              count: rentRollCount['rent_roll'] || 0,
              onClick: () => this.handleTabChange('rent_roll', { subset: 'rent_roll' }),
            },
            {
              title: getTranslatedString('landlordPortal.rentRoll.previous'),
              label: getTranslatedString('landlordPortal.rentRoll.previous'),
              value: 'previous',
              count: rentRollCount['previous'] || 0,
              onClick: () => this.handleTabChange('previous', { subset: 'previous' }),
            },
            {
              title: getTranslatedString('landlordPortal.rentRoll.upcoming'),
              label: getTranslatedString('landlordPortal.rentRoll.upcoming'),
              value: 'upcoming',
              count: rentRollCount['upcoming'] || 0,
              onClick: () => this.handleTabChange('upcoming', { subset: 'upcoming' }),
            },
            {
              title: getTranslatedString('landlordPortal.rentRoll.renewing'),
              label: getTranslatedString('landlordPortal.rentRoll.renewing'),
              value: 'renewing',
              count: rentRollCount['renewing'] || 0,
              onClick: () => this.handleTabChange('renewing', { subset: 'renewing' }),
            },
            {
              title: getTranslatedString('landlordPortal.rentRoll.expiringSoon'),
              label: getTranslatedString('landlordPortal.rentRoll.expiringSoon'),
              value: 'expiring_soon',
              count: rentRollCount['expiring_soon'] || 0,
              onClick: () => this.handleTabChange('expiring_soon', { subset: 'expiring_soon' }),
            },
            {
              title: getTranslatedString('landlordPortal.rentRoll.vacant'),
              label: getTranslatedString('landlordPortal.rentRoll.vacant'),
              value: 'vacant',
              count: rentRollCount['vacant'] || 0,
              onClick: () => this.handleTabChange('vacant', { subset: 'vacant' }),
            },
            {
              title: getTranslatedString('landlordPortal.rentRoll.all'),
              label: getTranslatedString('landlordPortal.rentRoll.all'),
              value: 'all',
              count: rentRollCount['all'] || 0,
              onClick: () => this.handleTabChange('all', { subset: 'all' }),
            },
          ];

          return (
            <StyledMain>
              <StyledHeaderContainer>
                <StyledHeader>
                  <HeaderWithPeriod
                    headerText={
                      <span>{getTranslatedString('landlordPortal.rentRoll.rentRoll')}</span>
                    }
                    newStyle
                  />
                  <RenderIfToggleOn toggle="ui.rent_roll_page.add_lease">
                    <StyledAddButton
                      accentColor={this.accentColor}
                      onClick={() => browserHistory.push('/companies/manual_lease_creator')}
                    >
                      {getTranslatedString('landlordPortal.rentRoll.addLease')}
                    </StyledAddButton>
                  </RenderIfToggleOn>
                </StyledHeader>
                <TableFilters
                  filters={filters}
                  handleSubmitFilters={this.handleFilters}
                  handleClearFilters={this.handleClearSearch}
                  filterOptions={filterOptions}
                  accentColor={this.accentColor}
                />
              </StyledHeaderContainer>

              <RentRollNonGrid
                getRentRollData={this.fetchRentRoll}
                getLeaseData={this.props.openEditLease}
              />

              <StyledTableContainer>
                {this._renderTableView({ rentRoll, tabs })}
                {this._renderMobileView({
                  rentRoll,
                  tabs,
                  currentTab: this.state.currentTab,
                  tabChange: this.handleTabChange,
                })}
              </StyledTableContainer>

              {this.renderLeaseDetails()}

              <InPersonDocumentSigningWizard
                showInPersonDocumentSigningWizard={this.state.inPersonDocumentSigning}
                closeInPersonDocumentSigningWizard={this.toggleInPersonDocumentSigning}
              />
              <YardiRenewalsWizard />
            </StyledMain>
          );
        }

        renderLeaseDetails = () => (
          <MuiThemeProvider theme={createMuiTheme(drawerStyle)}>
            <Drawer
              open={this.state.showDrawer}
              onClose={this.toggleDrawer}
              anchor="left"
              disableEnforceFocus={true}
            >
              <LeaseOverview
                toggleDrawer={this.toggleDrawer}
                leaseDetails={this.props.leaseDetails}
                updateLeaseDetails={this.updateLeaseDetails}
                fetchRentRollAndStats={this.fetchRentRollAndStats}
                fetchRentRoll={this.fetchRentRoll}
                getLeaseData={this.props.openEditLease}
                toggleInPersonDocumentSigning={this.toggleInPersonDocumentSigning}
              />
            </Drawer>
          </MuiThemeProvider>
        );

        _renderMobileView = ({ rentRoll, tabs, currentTab, tabChange }) => {
          let groupBy = 'property_name';
          if (featureEnabled('ui.properties.namespace_by_city')) {
            groupBy = 'property_name_city';
          }
          return (
            <MediaQuery query="(max-device-width: 750px)">
              <MobileTable
                groupRowsBy={groupBy}
                data={rentRoll}
                tabs={tabs}
                tabIndex={currentTab}
                tabChange={tabChange}
                filtersActive={this.state.filtersActive}
                columns={this.columns()}
                title="full_name"
                tag="status"
                tagType="rentRoll"
                stickyHeaderTop={this.state.filters.search ? '137px' : '107px'}
                hideOptionsIfBlank="cotenant_full_names"
                fieldsAboveFold={[
                  {
                    title: getTranslatedString('landlordPortal.rentRoll.unitNumber'),
                    key: 'unit_number',
                  },
                  {
                    title: getTranslatedString('landlordPortal.rentRoll.residents'),
                    key: 'cotenant_full_names',
                  },
                ]}
                fieldsBelowFold={[
                  {
                    title: getTranslatedString('landlordPortal.rentRoll.totalMonthlyRent'),
                    key: 'total_monthly_rent',
                    dataType: 'money',
                  },
                  {
                    title: getTranslatedString('landlordPortal.rentRoll.moveInDate'),
                    key: 'lease_start_date',
                  },
                  {
                    title: getTranslatedString('landlordPortal.rentRoll.leaseEndDate'),
                    key: 'lease_end_date',
                  },
                  {
                    title: getTranslatedString('landlordPortal.rentRoll.hasGuarantor'),
                    key: 'has_guarantor',
                    dataType: 'boolean',
                  },
                ]}
                onRowClick={data => {
                  this.toggleDrawer(data.id);
                }}
              />
            </MediaQuery>
          );
        };

        _renderTableView = ({ rentRoll, tabs }) => {
          let groupBy = 'property_name';
          if (featureEnabled('ui.properties.namespace_by_city')) {
            groupBy = 'property_name_city';
          }
          return (
            <MediaQuery query="(min-device-width: 750px)">
              <TabbedTable
                setRef={this.setRef}
                groupRowsBy={groupBy}
                tabs={tabs}
                columns={this.columns()}
                data={rentRoll}
                loadMoreData={this.fetchRentRoll}
                isLoading={this.props.fetchingRentRoll}
                filtersActive={this.state.filtersActive}
                onRowClick={data => {
                  if (
                    typeof data.original_id !== 'string' &&
                    !data.original_id.toString().startsWith('vacant')
                  ) {
                    this.toggleDrawer(data.original_id);
                  }
                }}
                onColumnClick={data => {
                  this.handleSort(data.key, data.order);
                }}
              />
            </MediaQuery>
          );
        };
      }
    )
  )
);
